import { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import MDEditor from "@uiw/react-md-editor";
import { useTranslation } from "react-i18next";
import DetailedContainer from "./detailedContainer";
import { CustomDiv } from "@/common/divs";
import { AlmostBoldPText, DivLightText } from "@/common/texts";
import { useGoogleTranslation } from "@/hooks/useGoogleTranslation";
import { ActivityAddressVm, ActivityDetailVm } from "@/model";
import { StaticInfoType } from "@/types/components";

const StaticActivityInfo: React.FC<{
  location: ActivityAddressVm;
  info: StaticInfoType;
  more_info: ActivityDetailVm | undefined;
}> = ({ location, info, more_info }) => {
  const markdownRef = useRef<any>(null);
  const { t } = useTranslation();
  const { getTranslation, translation } = useGoogleTranslation();

  useEffect(() => {
    if (markdownRef !== null && markdownRef.current !== null) {
      // console.log(markdownRef.current.outerHTML);
      getTranslation(markdownRef.current.innerHTML, "html");
    }
  }, [getTranslation, markdownRef]);

  return (
    <CustomDiv marginY="25px">
      <AlmostBoldPText
        fontSize="22px"
        style={{ marginBottom: "16px", marginTop: "30px" }}
      >
        {t("activity.general_info.title")}
      </AlmostBoldPText>
      <DetailedContainer
        location={location}
        info={info}
        more_info={more_info}
      />
      <AlmostBoldPText
        fontSize="22px"
        style={{ marginBottom: "16px", marginTop: "30px" }}
      >
        {t("activity.map.search_for_description")}
      </AlmostBoldPText>
      <Box ref={markdownRef} sx={{ display: "none" }}>
        <MDEditor.Markdown
          source={info.description}
          wrapperElement={{
            "data-color-mode": "light",
          }}
        />
      </Box>
      <DivLightText
        style={{
          marginTop: "16px",
          textAlign: "justify",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: translation }} />
      </DivLightText>
      {/* <LightText
        style={{
          marginTop: "16px",
          textAlign: "justify",
          whiteSpace: "break-spaces",
        }}
      >
        {translation.length > 0 ? translation : info.description}
      </LightText> */}
    </CustomDiv>
  );
};

export default StaticActivityInfo;
